import { useWalletView } from '#/features/wallet/wallet-context';
import { useTranslation } from '#/features/localization/utils';

import * as Alert from '#/components/common/Alert';
import { Paragraph } from '#/components/shared/Modal';

import WalletConnectModal from './WalletConnectModal';
import WalletConnectButton from './WalletConnectButton';
import LegalDisclaimer from './LegalDisclaimer';
import * as Modal from './Modal';

interface Props {
  readonly isOpen: boolean;
  readonly closeModal: () => void;
}

export default function WalletModalConnect(props: Props) {
  const { isOpen, closeModal } = props;

  const walletView = useWalletView();
  const { t } = useTranslation();

  // Prevents loading WalletConnect assets until the modal is opened.
  if (!isOpen) return;

  return (
    <>
      <Modal.Root isOpen={isOpen} onDismiss={closeModal}>
        <Modal.Header>
          <Modal.Title>{t('Connect your Wallet')}</Modal.Title>
          {walletView.status === 'idle' && (
            <Modal.CloseButton onClick={closeModal} />
          )}
        </Modal.Header>

        <Paragraph>
          <LegalDisclaimer />
        </Paragraph>

        <WalletConnectButton />
        {walletView.error.length > 0 && (
          <Alert.Error>{walletView.error}</Alert.Error>
        )}
      </Modal.Root>
      <WalletConnectModal />
    </>
  );
}
